export const PERIODOS = [
  { value: "MENSAL", label: "Mensal" },
  { value: "BIMESTRAL", label: "Bimestral" },
  { value: "TRIMESTRAL", label: "Trimestral" },
  { value: "SEMESTRAL", label: "Semestral" },
  { value: "ANUAL", label: "Anual" },
];

export const PERIODO_DESCRICOES = {
  MENSAL: "Uma coluna por mês do exercício.",
  BIMESTRAL: "Agrupa os meses em seis bimestres.",
  TRIMESTRAL: "Agrupa os meses em quatro trimestres.",
  SEMESTRAL: "Agrupa os meses em dois semestres.",
  ANUAL: "Consolida o exercício em uma única coluna.",
};

export const ANOS = Array.from({ length: 3 }).map(
  (_, i) => new Date().getFullYear() - i,
);

export const filtrosIniciais = {
  periodo: "MENSAL",
  ano: new Date().getFullYear(),
  empresas: [],
};

export function labelPeriodo(periodo) {
  return PERIODOS.find((item) => item.value === periodo)?.label ?? "";
}
